<template>
  <Tabs
    class="page-tabs"
    type="card"
    v-model="activedTab"
    :before-remove="beforePageTabRemove"
    @on-tab-remove="pageTabRemove"
    @on-click="routerPush"
    @on-contextmenu="updateData"
    closable
  >
    <TabPane
      v-for="item in pageTabs"
      :key="item.path"
      :name="item.path"
      :label="item.meta.title"
      :icon="item.meta.class"
      :closable="!item.notClose"
      :contextMenu="true"
    ></TabPane>
      <template #contextMenu>
            <DropdownItem @click.native="refresh"><Icon class="refreshIcon"/><span>&nbsp;刷新</span></DropdownItem>
            <DropdownItem @click.native="closeTab('L')"><Icon class="leftIcon"/><span>&nbsp;关闭左侧</span></DropdownItem>
            <DropdownItem @click.native="closeTab('R')"><Icon class="rightIcon"/><span>&nbsp;关闭右侧</span></DropdownItem>
            <DropdownItem @click.native="closeTab('O')"><Icon class="otherIcon"/><span>&nbsp;关闭其他</span></DropdownItem>
      </template>
  </Tabs>
</template>
<script>
export default {
  data() {
    return {
      pageTabs: [
        {
          path: '/',
          meta: {
            title: '',//首页
            class: 'md-home',
          },
          query: {},
          notClose: true,
        },
      ],
      activedTab: '',
    }
  },
  watch: {
    $route: {
      handler(newValue) {
        if (newValue && newValue.matched.length > 0) {
          document.title = newValue.meta.title + '|雪王建店管理系统'
          this.activedTab = newValue.path
          if (!this.pageTabs.find((item) => item.path === newValue.path)) {
            this.pageTabs.push({
              path: newValue.path,
              meta: newValue.meta,
              query: newValue.query,
            })
            this.setPageTabsStorage(this.pageTabs)
          }
        }
      },
      immediate: true,
    },
  },
  created() {
    this.getPageTabs()
  },
  methods: {
    setPageTabsStorage(pageTabs) {
      // localStorage.pageTabs = []
      localStorage.pageTabs = JSON.stringify(pageTabs)
    },
    getPageTabs() {
      this.activedTab = this.$route.path
      if (
        this.$store.state.userInfo.type == 20 ||
        this.$store.state.userInfo.type == 64
      ) {
        this.pageTabs.push({
          path: '/im',
          meta: {
            title: '客服会话',
          },
          query: {},
          notClose: true,
        })
      }
      if (localStorage.pageTabs) {
        this.pageTabs = JSON.parse(localStorage.pageTabs)
      }
    },
    beforePageTabRemove() {
      if (this.pageTabs.length === 1) {
        this.$Notice.warning({
          title: '禁止操作',
          desc: `请至少保留一个页签！`,
        })
        return Promise.reject()
      } else {
        return Promise.resolve()
      }
    },
    refresh(){
     this.$router.go(0)
    },
    closeTab(location){
      const tabIndex = this.pageTabs.findIndex((item) => item.path === this.menuData.name)
      this.updateActiveState(tabIndex);
     if(location=='L'){//关闭左侧
      if(tabIndex>1){
        for(var i=tabIndex-1;i>0;i--){
            this.pageTabs.splice(i, 1)
        }
      }
     }else if(location=='R'){//关闭右侧
      if(tabIndex+1 != this.pageTabs.length){
        for(var v=this.pageTabs.length;v>tabIndex;v--){
            this.pageTabs.splice(v, 1)
        }
      }
     }else if(location=='O'){//关闭其他
        if(tabIndex>0){
          this.pageTabs=[this.pageTabs[0],this.pageTabs[tabIndex]]
        }else{
          this.pageTabs=[this.pageTabs[0]]
        }
      }
     this.setPageTabsStorage(this.pageTabs);
    },
    updateData(data){
      this.menuData=data;
    },
    pageTabRemove(path) {
      const tabIndex = this.pageTabs.findIndex((item) => item.path === path)
      this.pageTabs.splice(tabIndex, 1)
      if (tabIndex !== this.pageTabs.length) {
        // 并非最后一个
        this.$router.push(this.pageTabs[tabIndex]).catch(() => {}) //修复参数丢失的bug
        this.updateActiveState(tabIndex);
      } else {
        this.$router.push(this.pageTabs[tabIndex - 1]).catch(() => {}) //修复参数丢失的bug
        this.updateActiveState(tabIndex-1);
      }
      this.setPageTabsStorage(this.pageTabs)
    },
    closeAll() {
      // console.log('11111',this.pageTabs)
      if (this.pageTabs.length === 1) {
        this.$Notice.warning({
          title: '禁止操作',
          desc: `您在首页，目前未打开其他页面`,
        })
        return Promise.reject()
      } else {
        this.pageTabs = [this.pageTabs[0]]
        // console.log(this.pageTabs)
        this.$router.push(this.pageTabs[0].path)
        this.setPageTabsStorage(this.pageTabs)
      }
    },
    routerPush(path) {
      const tabIndex = this.pageTabs.findIndex((item) => item.path === path) //修复参数丢失的bug
      this.updateActiveState(tabIndex)
    },
    updateActiveState(tabIndex) {
      if(tabIndex!=undefined){
        var buy = document.getElementById(this.pageTabs[tabIndex].path); 
        buy.click();
      }
    }
  },
}
</script>
<style lang="stylus" scoped>
.page-tabs
  flex: 0 0 48px
  background: #F3F3F3
  >>>.ivu-tabs-bar
    margin-bottom: 0
    border: none !important
    .ivu-tabs-nav-container
     height: 48px !important
    .ivu-tabs-tab-active
      background: white !important
      color: #1456f0 !important
      border-color: #E7E7E7 !important

  >>>.ivu-tabs-tab
    border-top: 0 !important
    border-bottom: 0 !important
    border-left: 0 !important
    border-color: #E7E7E7 !important
    margin-right: 0 !important
    height 48px !important
    line-height:40px !important
    border-radius: 0 !important
  >>>.ivu-btn
    background: #f2f2f2
    cursor:pointer
    border: none
  >>>.ivu-tabs-nav-prev
      line-height 48px
      &:hover 
        background #eeeeee
  >>>.ivu-tabs-nav-next
      line-height 48px
      &:hover 
        background #eeeeee
  >>>.ivu-icon-md-home
      margin 0px !important
      font-size 19px !important
>>>.refreshIcon 
  height 13px
  padding-right 15px
  background url('../assets/img/refresh-icon.png') no-repeat
  background-size 12px
>>>.leftIcon 
  height 13px
  padding-right 15px
  background url('../assets/img/left-icon.png') no-repeat
  background-size 12px
>>>.rightIcon 
  height 13px
  padding-right 15px
  background url('../assets/img/right-icon.png') no-repeat
  background-size 12px
>>>.otherIcon 
  height 13px
  padding-right 15px
  background url('../assets/img/close-icon.png') no-repeat
  background-size 12px      
</style>
